export default __webpack_public_path__ + "static/media/punto-originario-a2u-default.1fa51681.svg";